// extracted by mini-css-extract-plugin
export default {"avatar":"UserCard_avatar__oiGVe","bio":"UserCard_bio__Itco9","empty":"UserCard_empty__FstvH","error":"UserCard_error__dFTcU"};